import Message from '@/utils/message';

// 监听网络连接
window.addEventListener('online', () => {
  Message.success('网络已连接，请重试');
}, false);

// 监听网络断开
window.addEventListener('offline', () => {
  Message.error('网络未连接，请检查网络后重试');
}, false);